import { useEffect, useRef } from "react"
import { useWorkspaceJobsStore } from "@/stores/workspace-jobs-store"

/** Вызывает onFinish, когда задача этого вида переходит из очереди или работы в завершённое состояние. */
export function useJobKindFinished(kind: string, onFinish: () => void) {
  const jobs = useWorkspaceJobsStore((s) => s.jobs)
  const statusRef = useRef<Record<number, string>>({})
  const onFinishRef = useRef(onFinish)
  onFinishRef.current = onFinish

  useEffect(() => {
    const own = jobs.filter((job) => job.job_kind === kind)
    const finished = own.some((job) => {
      const prev = statusRef.current[job.id]
      return (prev === "queued" || prev === "processing") && (job.status === "completed" || job.status === "failed")
    })
    statusRef.current = Object.fromEntries(own.map((job) => [job.id, job.status]))
    if (finished) onFinishRef.current()
  }, [jobs, kind])
}
